import { EntityInterface } from 'src/shared/types/base-entity-interface'
import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { AlignType, BorderType, PaddingType } from 'common/types/styleTypes'
import {
  BaseFieldInterface,
  FieldInterface,
} from 'common/types/entities/field-interface'
import {
  BaseCheckboxInterface,
  CheckboxInterface,
} from 'common/types/entities/CheckboxInterface'
import { ButtonInterface } from 'common/types/entities/button-interface'
import { ContactSlugEnum } from 'src/shared/enums/contact-fields-enum'

export enum FormSubentityTypeEnum {
  Field = 'field',
  Checkbox = 'checkbox',
  SubmitButton = 'submit_button',
}

export interface FormFieldInterface
  extends Pick<
    FieldInterface,
    'id' | 'htmlAttrId' | 'placeholder' | 'optional' | 'iconClassName'
  > {
  type: FormSubentityTypeEnum.Field
  slug: ContactSlugEnum
}

export interface FormCheckboxInterface
  extends Pick<
    CheckboxInterface,
    | 'id'
    | 'htmlAttrId'
    | 'content'
    | 'errorText'
    | 'optional'
    | 'color'
    | 'mobileColor'
    | 'padding'
    | 'mobilePadding'
  > {
  type: FormSubentityTypeEnum.Checkbox
}

export interface FormSubmitButtonInterface
  extends Pick<
    ButtonInterface,
    | 'id'
    | 'htmlAttrId'
    | 'text'
    | 'subText'
    | 'iconClassNameBefore'
    | 'iconClassNameAfter'
  > {
  type: FormSubentityTypeEnum.SubmitButton
}

export type FormSubentityInterface =
  | FormFieldInterface
  | FormCheckboxInterface
  | FormSubmitButtonInterface

export enum FormLayoutEnum {
  OneColumn = 'one_column',
  TwoColumns = 'two_columns',
}

interface FormActionInterface
  extends Pick<
    ButtonInterface,
    | 'redirectionType'
    | 'urlRedirect'
    | 'optInSuccessText'
    | 'optInSuccessTextColor'
  > {
  doubleOptIn: boolean
}

export type ButtonCommonStylesInterface = Pick<
  ButtonInterface,
  | 'buttonType'
  | 'alignSelf'
  | 'mobileAlignSelf'
  | 'width'
  | 'mobileWidth'
  | 'border'
  | 'mobileBorder'
  | 'textColor'
  | 'mobileTextColor'
  | 'subTextColor'
  | 'mobileSubTextColor'
  | 'background'
  | 'mobileBackground'
  | 'padding'
  | 'mobilePadding'
  | 'boxShadow'
  | 'mobileBoxShadow'
  | 'textFontSize'
  | 'mobileTextFontSize'
  | 'textFontFamily'
  | 'mobileTextFontFamily'
  | 'textFontWeight'
  | 'mobileTextFontWeight'
  | 'textFontStyle'
  | 'mobileTextFontStyle'
  | 'textFontFileId'
  | 'mobileTextFontFileId'
  | 'lineHeight'
  | 'mobileLineHeight'
  | 'subTextFontSize'
  | 'mobileSubTextFontSize'
  | 'subTextFontFamily'
  | 'mobileSubTextFontFamily'
  | 'subTextFontWeight'
  | 'mobileSubTextFontWeight'
  | 'subTextFontStyle'
  | 'mobileSubTextFontStyle'
  | 'subTextFontFileId'
  | 'mobileSubTextFontFileId'
  | 'hover'
  | 'mobileHover'
>

export type CheckboxCommonStylesInterface = Pick<
  BaseCheckboxInterface,
  | 'fontSize'
  | 'mobileFontSize'
  | 'lineHeight'
  | 'mobileLineHeight'
  | 'fontFamily'
  | 'mobileFontFamily'
  | 'fontWeight'
  | 'mobileFontWeight'
  | 'fontStyle'
  | 'mobileFontStyle'
  | 'fontFileId'
  | 'mobileFontFileId'
  | 'textAlign'
  | 'mobileTextAlign'
  | 'color'
  | 'mobileColor'
>

export type FieldCommonStylesInterface = Pick<
  BaseFieldInterface,
  | 'border'
  | 'mobileBorder'
  | 'color'
  | 'mobileColor'
  | 'backgroundColor'
  | 'mobileBackgroundColor'
  | 'padding'
  | 'mobilePadding'
  | 'boxShadow'
  | 'mobileBoxShadow'
  | 'fontSize'
  | 'mobileFontSize'
  | 'lineHeight'
  | 'mobileLineHeight'
  | 'textAlign'
  | 'mobileTextAlign'
>

export interface FormInterface extends EntityInterface {
  type: EntityTypeEnum.Form
  customName: string
  layout: FormLayoutEnum
  rowGap: number
  mobileRowGap: number
  columnGap: number
  subEntities: Array<FormSubentityInterface>
  buttonCommonStyles: ButtonCommonStylesInterface
  checkboxesCommonStyles: CheckboxCommonStylesInterface
  fieldsCommonStyles: FieldCommonStylesInterface
  action: FormActionInterface
  border?: Partial<BorderType>
  mobileBorder?: Partial<BorderType>
  padding: PaddingType
  mobilePadding?: PaddingType
  backgroundColor?: string
  mobileBackgroundColor?: string
}
